import axios from "axios";
import { providerRootUrl } from "../utils/panel-helpers/helpers";

export type AppConfig = {
  api_url: string;
  oauth_url: string;
  new_relic_browser_enabled?: boolean | string;
  new_relic_browser_application_id?: string;
  new_relic_browser_license_key?: string;
  new_relic_browser_account_id?: string;
  new_relic_browser_trust_key?: string;
  new_relic_browser_agent_id?: string;
  new_relic_browser_beacon?: string;
};

let appConfigPromise: Promise<AppConfig> | null = null;

async function loadAppConfig(): Promise<AppConfig> {
  const timestamp = new Date().getTime();
  const response = await axios.get<AppConfig>(
    `${window.location.origin}/${providerRootUrl}/config.json?v=${timestamp}`
  );

  return response.data;
}

export function fetchAppConfig(): Promise<AppConfig> {
  if (!appConfigPromise) {
    appConfigPromise = loadAppConfig();
  }

  return appConfigPromise;
}
